import { RestServiceUtils } from '../utils/RestServiceUtils';

const userService = {
    getUsersList: (organizationId, placeId, params) => {
        const URL = `/ums/${organizationId}/${placeId}/user`;
        return RestServiceUtils.HTTP_GET(URL, params);
    },

    deleteUsers: (organizationId, placeId, userIds) => {
        const URL = `/ums/${organizationId}/${placeId}/user`;
        return RestServiceUtils.HTTP_DELETE(URL, userIds);
    },

    updateUsers: (organizationId, placeId, payload) => {
        const URL = `/ums/${organizationId}/${placeId}/user`;
        return RestServiceUtils.HTTP_PUT(URL, payload, {}, false);
    },

    addUsers: (organizationId, placeId, payload) => {
        const URL = `/ums/${organizationId}/${placeId}/user`;
        return RestServiceUtils.HTTP_POST(URL, payload, {}, false);
    },
};

export default userService;
